<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  class="highcharts-light"
  (chartInstance)="setChart($event)"
  >
</highcharts-chart>
